<mat-card>
	<mat-card-header>
	    <mat-card-title></mat-card-title>
	</mat-card-header>
    <mat-card-content>
        <form action="" method="post" [formGroup]="uploadForm"
                   enctype="multipart/form-data">
	        <div style="display:flex;flex-direction:row;gap:20px">
	            <mat-form-field style="width:25%" appearance="outline">
	                <mat-label>Document Name</mat-label>
		            <input matInput 		                   
                        type="text"
                        style="text-transform:uppercase"
                        id="docName"
                        name="docName" 				        
                        formControlName="docName"
                        placeholder="Document Name"
                        (input)="onDocNameInput()">

		        </mat-form-field>
	            <mat-form-field style="width:55%" appearance="outline">
	                <mat-label>Document Description</mat-label>
		            <input matInput 
                        type="text"
                        style="text-transform:uppercase"
                        id="docDescription"
                        name="docDescription" 				        
                        formControlName="docDescription"
                        placeholder="Document Description"
                        (input)="checkDirty(newDocument.description, 'docDescription'); onDocDescriptionInput()">

		        </mat-form-field>					    
		    </div>
		    <div>
                <button type="button" 
                        mat-raised-button 
                        color="accent"
                        (click)="fileInput.click()"
                        [disabled]="(entityUId == null || uploadDisabled)">
                        <i class="material-icons left">cloud</i> Choose File
                </button>
                <!-- Adding a div to hide the input because 
                     the hidden attribute does not work on input HTML tag
                 -->
                <input type="file"
                       id="file"
                       class="document-file-input"
                       multiple
                       (change)="onFileSelected($event)"
                       #fileInput>
		    </div>
        </form>
        <div class="container">
	        <div class="line"><mat-divider inset=“true”></mat-divider></div>
	        <div class="text mat-typography"><h2>Document List</h2></div>
	        <div class="line"><mat-divider inset=“true”></mat-divider></div>
        </div>                                
        <div class="document-toolbar">
            <mat-form-field appearance="outline"
                class="document-search-field">
                <mat-label>Search by name or owner</mat-label>
                <input matInput
                    [formControl]="searchTextFC"
                    placeholder="Search documents">
            </mat-form-field>
            <div class="document-combine-actions"
                *ngIf="isListView()">
                <mat-form-field appearance="outline"
                    class="document-combine-name-field">
                    <mat-label>Archive name</mat-label>
                    <input matInput
                        [formControl]="combineNameFC"
                        placeholder="Archive name"
                        [disabled]="!canCombineSelectedDocuments()">
                </mat-form-field>
                <button type="button"
                    mat-raised-button
                    color="primary"
                    class="document-combine-button"
                    (click)="combineSelectedDocuments()"
                    [disabled]="!canCombineSelectedDocuments()">
                    Archive
                </button>
            </div>
        </div>
        <div *ngIf="!isListView()"
            style="display:flex;flex-wrap:wrap;gap:20px">
            <ng-container *ngFor="let oneDocument of documents; let i=index">
                <div *ngIf="isNewRow(i)"
                     style="flex-basis:100%;height:0">
                </div>                        
                <div style="clear:both;justify-content:center;align-items:center;width:250px">
                    <ngx-avatars  (clickOnAvatar)="avatarClicked($event, oneDocument)"			                              
  		                         name="{{getDocumentFileType(oneDocument.fileTypeREF)}}"
		                         [style]="customStyle"
		                         value="{{getDocumentLabel(oneDocument.entityType)}}" 
		                         bgColor="#000000" 
		                         fgColor="#58D3F7" size="60"
		                         textSizeRatio="2.5" [round]="true">
                    </ngx-avatars>
                    <br>  
                    <span *ngIf="oneDocument.edit"
                        class="document-name-label"
                        [matTooltip]="getDocumentDescriptionTooltip(
                            oneDocument)"
                        [matTooltipDisabled]="
                            !hasDocumentDescriptionTooltip(oneDocument)"
                        matTooltipPosition="above">
                        {{oneDocument.name}}
                    </span>
                    <div *ngIf="!oneDocument.edit"
                        class="document-inline-edit">
                        <mat-form-field appearance="outline"
                            class="document-inline-field">
                            <mat-label>Document Name</mat-label>
                            <input matInput
                                type="text"
                                style="text-transform:uppercase"
                                [value]="oneDocument.editName"
                                (input)="onEditNameInput(
                                    oneDocument, $event)">
                        </mat-form-field>
                        <mat-form-field appearance="outline"
                            class="document-inline-field">
                            <mat-label>Description</mat-label>
                            <input matInput
                                type="text"
                                style="text-transform:uppercase"
                                [value]="oneDocument.editDescription"
                                (input)="onEditDescriptionInput(
                                    oneDocument, $event)">
                        </mat-form-field>
                    </div>
                    <br/>
                    <span style="position:absolute; padding-left:0px; 
                          text-align:left;width:200px;word-wrap:break-word">Uploaded By: {{oneDocument.byUser}}</span>	                	              	                
                    <br/>
                    <span style="position:absolute; padding-left:0px; 
                          text-align:left;width:200px;word-wrap:break-word">Upload date: {{CyDateTime.convertTimestampToLocalDateDisp(oneDocument.createDT)}}</span>	                	              	                
                    <br/>
                    <br/>
                    <div class="document-actions">
                        <button *ngIf="oneDocument.edit"
                            type="button"
                            mat-icon-button
                            color="primary"
                            matTooltip="Rename document"
                            (click)="editDocument(i, oneDocument)">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button *ngIf="oneDocument.edit"
                            type="button"
                            mat-icon-button
                            color="warn"
                            matTooltip="Delete document"
                            (click)="confirmDeleteDocument(
                                i, oneDocument)">
                            <mat-icon>delete</mat-icon>
                        </button>
                        <button *ngIf="!oneDocument.edit"
                            type="button"
                            mat-icon-button
                            color="primary"
                            matTooltip="Save changes"
                            (click)="saveDocument(i, oneDocument)">
                            <mat-icon>save</mat-icon>
                        </button>
                        <button *ngIf="!oneDocument.edit"
                            type="button"
                            mat-icon-button
                            color="primary"
                            matTooltip="Cancel edit"
                            (click)="cancelEdit(i, oneDocument)">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                </div>
            </ng-container>                                         
        </div>
        <div *ngIf="isListView()" class="document-list-table-wrap">
            <table class="document-list-table">
                <thead>
                    <tr>
                        <th>Select</th>
                        <th>Name</th>
                        <th>Owner</th>
                        <th>Upload Date</th>
                        <th>Type</th>
                        <th class="document-list-actions-col">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let oneDocument of documents;
                        let i=index">
                        <td>
                            <mat-checkbox
                                [checked]="isDocumentSelected(
                                    oneDocument.id)"
                                (change)="toggleDocumentSelection(
                                    oneDocument.id,
                                    $event.checked)">
                            </mat-checkbox>
                        </td>
                        <td>
                            <span *ngIf="oneDocument.edit"
                                class="document-name-label"
                                [matTooltip]="getDocumentDescriptionTooltip(
                                    oneDocument)"
                                [matTooltipDisabled]="
                                    !hasDocumentDescriptionTooltip(
                                        oneDocument)"
                                matTooltipPosition="above">
                                {{oneDocument.name}}
                            </span>
                            <div *ngIf="!oneDocument.edit"
                                class="document-inline-edit">
                                <mat-form-field appearance="outline"
                                    class="document-inline-field">
                                    <mat-label>Name</mat-label>
                                    <input matInput
                                        type="text"
                                        style="text-transform:uppercase"
                                        [value]="oneDocument.editName"
                                        (input)="onEditNameInput(
                                            oneDocument, $event)">
                                </mat-form-field>
                                <mat-form-field appearance="outline"
                                    class="document-inline-field">
                                    <mat-label>Description</mat-label>
                                    <input matInput
                                        type="text"
                                        style="text-transform:uppercase"
                                        [value]="oneDocument.editDescription"
                                        (input)="onEditDescriptionInput(
                                            oneDocument, $event)">
                                </mat-form-field>
                            </div>
                        </td>
                        <td>{{oneDocument.byUser}}</td>
                        <td>
                            {{CyDateTime.convertTimestampToLocalDateDisp(
                                oneDocument.createDT)}}
                        </td>
                        <td>
                            {{getDocumentFileType(
                                oneDocument.fileTypeREF)}}
                        </td>
                        <td class="document-list-actions-col">
                            <div class="document-list-actions">
                            <button type="button"
                                mat-icon-button
                                color="primary"
                                matTooltip="View document"
                                (click)="avatarClicked(
                                    $event, oneDocument)">
                                <mat-icon>visibility</mat-icon>
                            </button>
                            <button *ngIf="oneDocument.edit"
                                type="button"
                                mat-icon-button
                                color="primary"
                                matTooltip="Rename document"
                                (click)="editDocument(
                                    i, oneDocument)">
                                <mat-icon>edit</mat-icon>
                            </button>
                            <button *ngIf="oneDocument.edit"
                                type="button"
                                mat-icon-button
                                color="warn"
                                matTooltip="Delete document"
                                (click)="confirmDeleteDocument(
                                    i, oneDocument)">
                                <mat-icon>delete</mat-icon>
                            </button>
                            <button *ngIf="!oneDocument.edit"
                                type="button"
                                mat-icon-button
                                color="primary"
                                matTooltip="Save changes"
                                (click)="saveDocument(
                                    i, oneDocument)">
                                <mat-icon>save</mat-icon>
                            </button>
                            <button *ngIf="!oneDocument.edit"
                                type="button"
                                mat-icon-button
                                color="primary"
                                matTooltip="Cancel edit"
                                (click)="cancelEdit(
                                    i, oneDocument)">
                                <mat-icon>close</mat-icon>
                            </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </mat-card-content>
</mat-card>
